/**
 * 🧪 「연금술사가 되었다」 진입점 — resources/views/pop/alchemist.blade.php 의 마운트 지점에 붙는다.
 *
 * ⚠️ 이 파일은 vite.config.js 의 manualChunks 에서 제외된다 — 다른 SPA 청크와 섞이면 두 앱이 동시에 마운트된다(GV 전력).
 */
import { mount } from 'svelte';
import App from './App.svelte';

const target = document.getElementById('pop-alchemist');
if (!target) {
    throw new Error('Pop alchemist mount target not found');
}

const shareUrl = target.dataset.shareUrl || `${location.origin}${location.pathname}`;
target.innerHTML = '';

export default mount(App, { target, props: { shareUrl } });
